export enum AuthEventType {
    OnAuthError = 'OnAuthError',
    OnAuthLogout = 'OnAuthLogout',
    OnAuthRefreshError = 'OnAuthRefreshError',
    OnAuthRefreshSuccess = 'OnAuthRefreshSuccess',
    OnAuthSuccess = 'OnAuthSuccess',
    OnTokenExpired = 'OnTokenExpired',
    OnActionUpdate = 'OnActionUpdate',
    OnReady = 'OnReady',
}

export interface AuthEvent {
    type: AuthEventType;
    args?: unknown;
}
